import React from 'react';

const ExecutiveSummary = ({ data }) => {
  if (!data) return null;

  const { decision, decisionEmoji, decisionContext, primaryFocus, actionSentence, phase, weeklyTarget, verdict } = data;

  // Dynamic colors based on decision
  const getDecisionColor = (emoji) => {
    if (emoji === '🟢') return 'text-green-400 border-green-500/30 bg-green-500/10';
    if (emoji === '🟡') return 'text-yellow-400 border-yellow-500/30 bg-yellow-500/10';
    if (emoji === '🔴') return 'text-red-400 border-red-500/30 bg-red-500/10';
    return 'text-blue-400 border-blue-500/30 bg-blue-500/10';
  };

  const colorClass = getDecisionColor(decisionEmoji);

  return (
    <section className="bg-gray-800 rounded-2xl p-6 border border-gray-700 shadow-xl relative overflow-hidden">
        {/* Background Glow Effect */}
        <div className={`absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-white/5 to-transparent rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none`}></div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 relative z-10">
            
            {/* Left: Decision & Verdict */}
            <div className="flex-1 space-y-4">
                <div className="flex items-center gap-4">
                    <div className={`text-4xl md:text-5xl shadow-sm p-3 rounded-2xl border ${colorClass}`}>
                        {decisionEmoji}
                    </div>
                    <div>
                        <h2 className="text-gray-400 text-sm uppercase tracking-wider font-semibold">Coach Decision</h2>
                        <div className="flex items-baseline gap-2">
                             <span className={`text-2xl md:text-3xl font-bold ${colorClass.split(' ')[0]}`}>
                                {decision}
                             </span>
                             <span className="text-gray-500 text-sm hidden sm:inline-block">
                                {decisionContext}
                             </span>
                        </div>
                    </div>
                </div>
                
                <div className="bg-gray-900/50 p-4 rounded-xl border border-gray-700/50">
                    <p className="text-gray-300 text-lg leading-relaxed">
                        <span className="text-orange-400 font-medium">Verdict:</span> {verdict}
                    </p>
                </div>
            </div>

            {/* Right: Phase & Focus */}
            <div className="w-full md:w-auto flex flex-col gap-3 min-w-[200px]">
                 <div className="bg-gray-700/30 p-3 rounded-lg border border-gray-600/30">
                     <p className="text-xs text-gray-400 uppercase">Primary Focus</p>
                     <p className="text-white font-medium">{primaryFocus}</p>
                 </div>
                 
                 <div className="bg-gray-700/30 p-3 rounded-lg border border-gray-600/30">
                     <p className="text-xs text-gray-400 uppercase">Current Phase</p>
                     <p className="text-blue-300 font-medium">{phase}</p>
                 </div>

                 <div className="bg-gray-700/30 p-3 rounded-lg border border-gray-600/30">
                     <p className="text-xs text-gray-400 uppercase">Weekly Target</p>
                     <p className="text-white font-medium">{weeklyTarget} km</p>
                 </div>
            </div>
        </div>
        
        {/* Action sentence footer */}
        <div className="mt-6 pt-4 border-t border-gray-700/50 flex items-center gap-2">
            <span className="text-orange-500">⚡</span>
            <p className="text-gray-300 italic text-sm">"{actionSentence}"</p>
        </div>
    </section>
  );
};

export default ExecutiveSummary;
